import { dateFormat } from './date.format';

/**
 * Formata data de quitação opcional, retornando "-" quando null/undefined
 * @param value - Data para formatar
 * @returns Data formatada ou "-"
 */
export const dateOptionalFormat = (value: string): string => {
  if (!value) return '-';
  return dateFormat(value);
};
